/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CustomLabel } from "../../ui/labels";
import { StylesDatePicker } from "../../ui/stylesDatePicker";
import { configDatePickerLenguage } from "../RelevosInfoGeneral/utils";
import { ButtonPrimary } from "../../ui/buttons";

const DateRangeComponentV2 = ({ pagingController, history, label, id }) => {
  const [renderYearContent, setRenderYearContent] = useState(false);
  const [renderQuarterContent, setRenderQuarterContent] = useState(false);
  const [renderMonthContent, setRenderMonthContent] = useState(false);
  const locale = configDatePickerLenguage();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  // configura los params cuando se elige año, trimestre o mes
  useEffect(() => {
    // Inicializa el rango de fechas desde la query al cargar la página
    if (pagingController.query && pagingController.query.startDate && pagingController.query.endDate) {
      const start = moment(pagingController.query.startDate, "DD/MM/YY").toDate();
      const end = moment(pagingController.query.endDate, "DD/MM/YY").toDate();
      setDateRange([start, end]);
      pagingController.setFilterValue({ startDate: start, endDate: end });
    }
  }, []);

  useEffect(() => {
    // Actualiza los filtros y recarga los datos cuando cambian las fechas
    if (startDate && endDate) {
      pagingController.setFilterValue({ startDate, endDate });
      pagingController.reloadData(history.location);
    }
  }, [startDate, endDate]); // Se ejecuta solo cuando cambian las fechas

  const handleDatesChange = (values) => {
    // Maneja el cambio de fechas desde el selector
    if (!values) {
      setDateRange([null, null]);
      pagingController.setFilterValue({ startDate: null, endDate: null });
    } else {
      const start = moment(values);
      let end;
      if (renderYearContent) {
        end = new Date(moment(values).add(1, "years").subtract(1, "days"));
      } else if (renderQuarterContent) {
        end = new Date(moment(values).add(1, "quarter").subtract(1, "days"));
      } else if (renderMonthContent) {
        end = new Date(moment(values).add(1, "months").subtract(1, "days"));
      } else {
        [, end] = values;
      }
      setDateRange([start, end]);
    }
  };

  // formatea el valor del rango de fechas
  const getDataRangeValue = (inputStartDate, inputEndDate) => {
    const start = inputStartDate ? moment(inputStartDate).format("DD/MM/YY") : "";
    const end = inputEndDate ? moment(inputEndDate).format("DD/MM/YY") : "";
    return `${start} - ${end}`;
  };

  // se configura el date Picker para mostrar año, trimesre, mes o dia
  const dateRangeShow = (type) => {
    if (type === "day") {
      setRenderYearContent(false);
      setRenderQuarterContent(false);
      setRenderMonthContent(false);
    } else if (type === "month") {
      setRenderMonthContent(true);
      setRenderYearContent(false);
      setRenderQuarterContent(false);
    } else if (type === "quarter") {
      setRenderQuarterContent(true);
      setRenderYearContent(false);
      setRenderMonthContent(false);
    } else if (type === "year") {
      setRenderYearContent(true);
      setRenderQuarterContent(false);
      setRenderMonthContent(false);
    }
    pagingController.setFilterValue({ startDate: null, endDate: null });
  };

  return (
    <div className="w-100 d-flex flex-column">
      {label && <CustomLabel htmlFor={id || "date-range"}>{label}</CustomLabel>}
      <StylesDatePicker twoMonths height="32px" right="0px" className="w-100">
        <DatePicker
          placeholderText="Todo"
          locale={locale}
          id={id || "date-range"}
          className="digits date-input"
          selectsRange={!renderYearContent && !renderQuarterContent && !renderMonthContent}
          startDate={pagingController.query.startDate || startDate}
          endDate={pagingController.query.endDate || endDate}
          onChange={(update) => {
            if (renderMonthContent || renderQuarterContent || renderYearContent) {
              handleDatesChange(update);
            } else {
              update ? setDateRange(update) : pagingController.setFilterValue({ startDate: null, endDate: null });
            }
          }}
          value={pagingController.query.startDate ? getDataRangeValue(pagingController.query.startDate || startDate, pagingController.query.endDate || endDate) : null}
          selected={pagingController.query.startDate ? pagingController.query.startDate : null}
          monthsShown={!(renderYearContent || renderQuarterContent || renderMonthContent) ? 2 : 1}
          showYearPicker={renderYearContent}
          showQuarterYearPicker={renderQuarterContent}
          showMonthYearPicker={renderMonthContent}
          isClearable
          clearButtonClassName="clear-button"
          autoComplete="off"
        >
          <div className="buttons mx-4">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("day")}>
                Días
              </ButtonPrimary>
              <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("month")}>
                Meses
              </ButtonPrimary>
              <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("quarter")}>
                Trimestre
              </ButtonPrimary>
              <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("year")}>
                Años
              </ButtonPrimary>
            </div>
          </div>
        </DatePicker>
      </StylesDatePicker>
    </div>
  );
};

export default DateRangeComponentV2;
